// extracted by mini-css-extract-plugin
export default {"Requisites":"Requisites_Requisites__JsWss"};